var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeOffFilled = function SvgVolumeOffFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "m5.875 8.625 3.979-3.371a1 1 0 0 1 1.646.763v11.965c0 .852-.997 1.314-1.646.763l-3.979-3.371",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M5.875 15.375H3.5a1 1 0 0 1-1-1v-4.75a1 1 0 0 1 1-1h2.375",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.875 15.374 3.979 3.371c.649.551 1.646.089 1.646-.763V6.017a1 1 0 0 0-1.646-.763L5.875 8.625H3.5a1 1 0 0 0-1 1v4.75a1 1 0 0 0 1 1h2.375M20.83 9.44l-5 5M20.83 14.44l-5-5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeOffFilled);
export default ForwardRef;